/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.AutoCheck.Entries <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 25.9.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 29.9.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.AutoCheckEntries", $.common.VisualBase, {
    logicIndex: 0,
    logicTemplates: null,
    _create: function () {
        var me = this;
        try {
        
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 323;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            
            //initiates the super class
            me._super();
           
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
          
            me.showMessage("", false);

            me.fnd("#lst-logic").height(parseInt(me.container.height - me.fnd("#div-menu").height() - me.fnd("#btn-add-new").height()
                - me.fnd("#div-logic-header").height() - 80));
           ;

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            //get all available logic template
           me.logicTemplates = JSON.parse(me.specific.templates);

            me.fnd("#btn-add-new").on("click",  function () { me._addNewLogic(); });
            me.fnd("#btn-add-new").button();
            
            me.visual.off("change", ".logic .ddl-template").on("change", ".ddl-template",
                function (e) { me._changeTemplate($(e.target));});

            me.visual.off("click", ".logic .btn-del").on("click", ".btn-del",
                function (e) {me._del($(e.target));});

            me.visual.off("change", ".logic .txt-logic-interval").on("change", ".txt-logic-interval",
                function (e) {
                    //we don't allow values < 1
                    if (parseInt($(e.target).val()) < 1) {
                        $(e.target).val(1);
                    }

                    me._validate();
                });

            me.visual.off("change", ".ddl-logic-report-user").on("change", ".ddl-logic-report-user",function (e) { me._validate();});


            me.fnd("#div-btn-save").on("click", function () { me._save(); }).removeClass("active");
            
            me._fetch();



            me.fnd('.vc-list-header .fa-info-circle').tipTip({defaultPosition:'bottom'});

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },


    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        try {


        
            me.fnd("#lst-logic").html(me.getLoadingIcon());

            me.getData("", function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
                }
               if (result.length === 0) {
                   me.fnd("#lst-logic").html("");
                   me.fnd("#div-btn-save").removeClass("active");
                   return true;
                }
               me.fnd("#lst-logic").html("");
               for (var i = 0; i < result.length; i++) {
                   me._addEntry(result[i]);
               }

                me.fnd("#div-btn-save").removeClass("active");

                return true;
            });

        } catch (e) { me.writeError('fetch', e); return false;}
        return true;
    },



    _addEntry: function (logic) {
        /// <summary>
        /// This function clones the logic template, sets the values of the given logic and adds it to the logic list
        /// </summary>
        var me = this;
        try {

          
            var tpl = me.visual.find("#div-logic-template").clone();
            tpl.attr("id", "div-logic-" + me.logicIndex);
            me._disable(tpl.find(".box").not(".ddl-template"), true);
           
            tpl.find("#div-template").data("guid", logic.GUID);

            tpl.find(".ddl-template").val(logic.ID);
            
            //set the active items based on the logic id
            me._changeTemplate(tpl.find(".ddl-template"));

            tpl.find(".ddl-logic-type").val(logic.LogicType);
            tpl.find(".ddl-logic-data-type").val(logic.LogicDataType);
            tpl.find(".ddl-logic-trigger").val(logic.LogicTrigger);
            tpl.find(".txt-logic-interval").val(logic.LogicInterval);
            tpl.find(".ddl-logic-interval-type").val(logic.LogicIntervalType);
            tpl.find(".ddl-logic-todo").val(logic.LogicTodo);
            tpl.find(".ddl-logic-report").val(logic.LogicReport);
            if (typeof (logic.LogicReportUserIds) !== "undefined") {
                tpl.find(".ddl-logic-report-user").val(logic.LogicReportUserIds[0]);
            } else {
                tpl.find(".ddl-logic-report-user").val(-1);
            }
            

            if (logic.LogicCommit) {
                tpl.find(".chb-logic-commit").prop("checked", "checked");
            }

            me.visual.find("#lst-logic").prepend(tpl);
         


            me.logicIndex += 1;

          

        } catch (e) { me.writeError('_addEntry', e); return false; }
        return true;
    },

    _validate: function () {
        /// <summary>
        /// This function saves everything
        /// </summary>
        var me = this;
        try {
       
            var entries = me.fnd("#lst-logic .logic");

            if (entries.find(":invalid").length > 0 || entries.find(".invalid").length > 0) {
                me.fnd("#div-btn-save").removeClass("active");
                return false;
            }
            

            me.fnd("#div-btn-save").not(".active").addClass("active");

        } catch (e) { me.writeError('validate', e); return false; }
        return true;
    },


    _save: function () {
        /// <summary>
        /// This function saves everything
        /// </summary>
        var me = this;
        try {
            var lst = [];
            var id;
            var entries = me.fnd("#lst-logic .logic");

          

            if (entries.find(":invalid").length > 0 || entries.find(".invalid").length > 0 ) {
                return false;
            }
       

            for (var i = entries.length - 1; i >= 0; i--) {
                id = parseInt($(entries[i]).find(".ddl-template").val());


                if (id >0) {
                    var logic = { ID: id };
                    logic.GUID = parseInt($(entries[i]).data("guid"));
                    logic.LogicType = parseInt($(entries[i]).find(".ddl-logic-type").val());
                    logic.LogicDataType = parseInt($(entries[i]).find(".ddl-logic-data-type").val());
                    logic.LogicTrigger = parseInt($(entries[i]).find(".ddl-logic-trigger").val());
                    logic.LogicInterval = parseInt($(entries[i]).find(".txt-logic-interval").val());
                    logic.LogicIntervalType = parseInt($(entries[i]).find(".ddl-logic-interval-type").val());

                    logic.LogicTodo = parseInt($(entries[i]).find(".ddl-logic-todo").val());
                    logic.LogicReport = parseInt($(entries[i]).find(".ddl-logic-report").val());
                    logic.LogicReportUserIds = [];
                    if (isNaN(parseInt($(entries[i]).find(".ddl-logic-report-user").val()))) {
                        logic.LogicReportUserIds = [];
                    } else {
                        logic.LogicReportUserIds.push(parseInt($(entries[i]).find(".ddl-logic-report-user").val()));
                    }

                 
                    logic.LogicCommit = $(entries[i]).find(".chb-logic-commit").prop("checked");

                 

                    lst.push(logic);

                }
            }
          

            me.updateData(lst, function (result) {

                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                me._fetch();
             
                return true;
            });

        } catch (e) { me.writeError('save', e); return false; }
        return true;
    },



    _addNewLogic: function () {
        /// <summary>
        /// This function clones the logic template and adds it as new entry to the list
        /// </summary>
        var me = this;
        try {

            var tpl = me.visual.find("#div-logic-template").clone();
            tpl.attr("id", "div-logic-" + me.logicIndex);
            tpl.find("#div-template").data("guid", "-1");
            me._disable(tpl.find(".box").not(".ddl-template"), true);

            tpl.find(".box").not(".ddl-template").addClass("invalid");

            me.visual.find("#lst-logic").prepend(tpl);

            me.logicIndex += 1;

            me._validate();

        } catch (e) { me.writeError('_addNewLogic', e); return false;}
        return true;
    },

    _changeTemplate: function (obj) {
        /// <summary>
        /// This function resets the active items when changing the template dropdown
        /// </summary>
        var me = this;
        try {

          
            var id = parseInt(obj.val());
            var logic = obj.parents(".logic");
            if (id === 0) {
                me._disable(logic.find(".box").not(".ddl-template"), true);
                logic.find(".chb-logic-commit").prop("checked", "");
                logic.find(".box").not(".ddl-template").removeClass("invalid").addClass("invalid");
                me._validate();
                return false;
            }
            logic.find(".box").not(".ddl-template").removeClass("invalid");
           
            var tpl = me.logicTemplates.find(x => x.ID === id);
      
            logic.find(".ddl-logic-type").val(tpl.LogicType);
            logic.find(".ddl-logic-data-type").val(tpl.LogicDataType);
            logic.find(".ddl-logic-trigger").val(tpl.LogicTrigger);
            logic.find(".txt-logic-interval").val(tpl.LogicInterval);
            logic.find(".ddl-logic-interval-type").val(tpl.LogicIntervalType);
            logic.find(".ddl-logic-todo").val(tpl.LogicTodo);

            logic.find(".ddl-logic-report").val(tpl.LogicReport);
           
            if (tpl.LogicCommit) {
                logic.find(".chb-logic-commit").prop("checked", "checked");
            }

            if (tpl.OnlyIntervalAllowed) {
                me._disable(logic.find(".box").not(".ddl-template"), true);
                me._disable(logic.find(".txt-logic-interval"), false);
                
            }  else {
                me._disable(logic.find(".box"), false);
            }

            if (tpl.LogicReport == 1) {
                logic.find(".ddl-logic-report-user").hide();
            } else {
                logic.find(".ddl-logic-report").hide();
                me._disable(logic.find(".ddl-logic-report-user"), false);
                //logic.find(".ddl-logic-report-user").chosen({ "placeholder_text_multiple": 'select', "no_results_text": 'nix', width:'130px'});
            }
            if (tpl.CommitAllowed) {
                me._disable(logic.find(".chb-logic-commit"), false);
            } else {
                me._disable(logic.find(".chb-logic-commit"), true);
            }
            me._validate();
        } catch (e) { me.writeError('_changeTemplate', e); return false; }
        return true;
    },

    _del: function (obj) {
        /// <summary>
        /// This function removes one entry from the list
        /// </summary>
        var me = this;
        try {

            obj.parents(".logic").remove();
            me._validate();
        } catch (e) { me.writeError('_disable', e); return false; }
        return true;
    },
    
    _disable: function (obj, bLock) {
        /// <summary>
        /// This function disables/enables an input field
        /// </summary>
        var me = this;
        try {

            if (bLock) {
                obj.prop("disabled", "disabled").prop("readonly", "readonly");
            } else {
                obj.prop("disabled", "").prop("readonly", "");
            }

        } catch (e) { me.writeError('_disable', e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-menu, #lst-logic, #btn-add-new, .vc-list").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

